import { formatCreatedDate } from '../../../utils/dates';
import type { DmEventItem } from '../../../services/dmEvents';
import { getEventLabel, getDotColor, getBorderColor, getBgColor } from '@odo/shared-ui';

function formatEventTime(isoDate: string): string {
    const d = new Date(isoDate);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
}

function EventRow({ event }: { event: DmEventItem }) {
    const dotColor = getDotColor(event.level);
    const borderColor = getBorderColor(event.level);
    const bgColor = getBgColor(event.level);
    const hasHighlight = event.level === 'alert' || event.level === 'warning';

    return (
        <div className="flex items-start gap-3 py-2">
            <div className="flex flex-col items-center pt-1.5 flex-shrink-0">
                <span className={`w-2 h-2 rounded-full ${dotColor}`} />
            </div>

            <div
                className={`flex-1 min-w-0 rounded-lg px-3 py-2.5 ${
                    hasHighlight ? `${bgColor} border-l-[3px] ${borderColor}` : 'bg-gray-50'
                }`}
            >
                <div className="flex flex-col gap-0.5">
                    <span className="text-sm font-semibold text-gray-800">
                        {getEventLabel(event.type)}
                    </span>
                    {event.title && (
                        <span className="text-xs text-gray-500 leading-relaxed line-clamp-2">
                            {event.title}
                        </span>
                    )}
                    {event.notificationComments.length > 0 && (
                        <div className="flex flex-col gap-0.5 mt-0.5">
                            {event.notificationComments.map((nc, i) => (
                                <span key={i} className="text-xs text-gray-500 line-clamp-1">
                                    {nc.title}
                                </span>
                            ))}
                        </div>
                    )}
                    <span className="text-[11px] text-gray-400 mt-1">
                        {formatCreatedDate(event.creationDate)} ·{' '}
                        {formatEventTime(event.creationDate)}
                    </span>
                </div>
            </div>
        </div>
    );
}

export { EventRow };
